export const appSettings = {
  FoysPubRegistrationsUrl: process.env.VUE_APP_FOYS_PUB_API_BASE_URL,
  RegistrationFormConfigId: process.env.VUE_APP_FOYS_REGISTRATION_FORM_CONFIG_ID,
};
